import type { Message } from '@oneToOne/shared/components/chat/types'

/**
 * Sorts messages for correct display order in UI.
 *
 * @returns Messages ordered by created_at
 */
export function sortMessages(messages: Message[]) {
  return messages.sort((a, b) => {
    if (a.created_at && b.created_at) {
      const messageACreatedAt = new Date(a.created_at).getTime()
      const messageBCreatedAt = new Date(b.created_at).getTime()

      if (messageACreatedAt < messageBCreatedAt) {
        return -1
      } else if (messageACreatedAt > messageBCreatedAt) {
        return 1
      } else {
        return 0
      }
    } else {
      return 0
    }
  })
}
